import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Button } from 'react-bootstrap';

import CommonFormComponent from '../../../CommonField/CommonFormComponent';

import validate from './validate';
import { encode } from '../../../../helpers/queryEncryption'
import { smtpFormFields } from '../../../../helpers/SmtpSetup/smtpSetupForm'
import { createSmtpData } from '../../../../actions/siteadmin/SmtpSetup/manageSmtpData';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

import bt from '../../../../components/commonStyle.css';
import s from './SmtpForm.css';
import messages from '../../../../locale/jsonMessages';

class SmtpForm extends Component {

  constructor(props) {
    super(props);
  }

  handleFormSubmit = async (values) => {
    const { createSmtpData, paginationData, currentPage, demoRestriction } = this.props;
    if (values?.id) {
      const isRestrict = await demoRestriction({ restrictType: 'SMTP', restrictValue: values?.id });
      if (isRestrict) return;
    }
    await createSmtpData({
      id: values?.id,
      smtpName: values?.smtpName,
      smtpHost: encode(values?.smtpHost),
      smtpPort: encode(values?.smtpPort),
      smtpEmail: encode(values?.smtpEmail),
      smtpSender: encode(values?.smtpSender),
      smtpSenderEmail: encode(values?.smtpSenderEmail),
      smtpPassword: encode(values?.smtpPassword),
      currentPage
    });
    !values?.id && paginationData(1);
  }

  render() {
    const { error, handleSubmit, submitting, id } = this.props;
    const { formatMessage } = this.props.intl;
    const formFields = smtpFormFields();

    return (
      <form onSubmit={handleSubmit(this.handleFormSubmit)}>
        {error && <strong>{formatMessage(error)}</strong>}
        <div className="oneColumnGrid">
          {
            formFields && formFields?.map((item) => {
              return (
                <Field
                  name={item}
                  type="text"
                  component={CommonFormComponent}
                  isRequiredInput
                  inputClass='commonInputField'
                  labelText={formatMessage({ id: item })}
                  placeholder={formatMessage({ id: item })}
                />
              )
            })
          }
        </div>
        <div className={cx(bt.spaceTop4, 'singleBtnFlexEnd')}>
          <Button className={cx(bt.btnPrimary)} type="submit" disabled={submitting}>
            {id ? <FormattedMessage  {...messages.update} /> : <FormattedMessage  {...messages.addLabel} />}
          </Button>
        </div>
      </form>
    )
  }
}

SmtpForm = reduxForm({
  form: "SmtpForm",
  validate,
})(SmtpForm);

const selector = formValueSelector('SmtpForm');

const mapState = (state) => ({
  id: selector(state, 'id')
});

const mapDispatch = {
  createSmtpData,
  demoRestriction
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(SmtpForm)));